import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { fetchTaxReceiptConfiguration } from '../../taxReceiptActions';

import DashboardNotification from './DashboardNotification';

const mapStateToProps = state => ({
  configuration: state.TaxReceipt.taxReceiptConfiguration
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchTaxReceiptConfiguration
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardNotification);

